import Color from '@bubble-dev/fantasy-color';
import { colorVersionBuilderDeprecated, createVersionedColorDeprecated, createInteractiveColorOf } from './helpers';
import { lollipopColorVariablesDark, lollipopColorVariablesLight } from './lollipopColor';
import { pancakeColorVariablesDark, pancakeColorVariablesLight } from './pancakeColor';
var Black15 = createInteractiveColorOf([0x00, 0x00, 0x00, 0.15], [0x2b, 0x2a, 0x2a, 0.15], [0x19, 0x19, 0x18, 0.15]);
var Black80 = createInteractiveColorOf([0x00, 0x00, 0x00, 0.8], [0x2b, 0x2a, 0x2a, 0.8], [0x19, 0x19, 0x18, 0.8]);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/accent-action' instead.
 */
export var [__backgroundAccent, __backgroundAccentHovered, __backgroundAccentPressed] = colorVersionBuilderDeprecated(['__backgroundAccent', '__backgroundAccentHovered', '__backgroundAccentPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/accent-action'
}, lollipopColorVariablesLight['colors/backgrounds/accent-action'], lollipopColorVariablesDark['colors/backgrounds/accent-action'], pancakeColorVariablesLight['colors/backgrounds/accent-action'], pancakeColorVariablesDark['colors/backgrounds/accent-action']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/accent-inline' instead.
 */
export var [__backgroundAccentInline, __backgroundAccentInlineHovered, __backgroundAccentInlinePressed] = colorVersionBuilderDeprecated(['__backgroundAccentInline', '__backgroundAccentInlineHovered', '__backgroundAccentInlinePressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/accent-inline'
}, lollipopColorVariablesLight['colors/backgrounds/accent-inline'], lollipopColorVariablesDark['colors/backgrounds/accent-inline'], pancakeColorVariablesLight['colors/backgrounds/accent-inline'], pancakeColorVariablesDark['colors/backgrounds/accent-inline']);

// backgrounds inverse and default are swapped in design tokens

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/default' instead.
 */
export var [__backgroundInverse, __backgroundInverseHovered, __backgroundInversePressed] = colorVersionBuilderDeprecated(['__backgroundInverse', '__backgroundInverseHovered', '__backgroundInversePressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/default'
}, lollipopColorVariablesLight['colors/backgrounds/default'], lollipopColorVariablesDark['colors/backgrounds/default'], pancakeColorVariablesLight['colors/backgrounds/default'], pancakeColorVariablesDark['colors/backgrounds/default']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/subtle-inline' instead.
 */
export var [__backgroundSubtleInline, __backgroundSubtleInlineHovered, __backgroundSubtleInlinePressed] = colorVersionBuilderDeprecated(['__backgroundSubtleInline', '__backgroundSubtleInlineHovered', '__backgroundSubtleInlinePressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/subtle-inline'
}, lollipopColorVariablesLight['colors/backgrounds/subtle-inline'], lollipopColorVariablesDark['colors/backgrounds/subtle-inline'], pancakeColorVariablesLight['colors/backgrounds/subtle-inline'], pancakeColorVariablesDark['colors/backgrounds/subtle-inline']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0
 */
export var [__backgroundSubtleFloating, __backgroundSubtleFloatingHovered, __backgroundSubtleFloatingPressed] = colorVersionBuilderDeprecated(['__backgroundSubtleFloating', '__backgroundSubtleFloatingHovered', '__backgroundSubtleFloatingPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/subtle-floating'
}, lollipopColorVariablesLight['colors/backgrounds/subtle-floating'], lollipopColorVariablesDark['colors/backgrounds/subtle-floating'], pancakeColorVariablesLight['colors/backgrounds/subtle-floating'], pancakeColorVariablesDark['colors/backgrounds/subtle-floating']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/neutral' instead.
 */
export var [__backgroundNeutral, __backgroundNeutralHovered, __backgroundNeutralPressed] = colorVersionBuilderDeprecated(['__backgroundNeutral', '__backgroundNeutralHovered', '__backgroundNeutralPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/neutral'
}, lollipopColorVariablesLight['colors/backgrounds/neutral'], lollipopColorVariablesDark['colors/backgrounds/neutral'], pancakeColorVariablesLight['colors/backgrounds/neutral'], pancakeColorVariablesDark['colors/backgrounds/neutral']);

// backgrounds inverse and default are swapped in design tokens

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/inverse' instead.
 */
export var [__backgroundDefault, __backgroundDefaultHovered, __backgroundDefaultPressed] = colorVersionBuilderDeprecated(['__backgroundDefault', '__backgroundDefaultHovered', '__backgroundDefaultPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/inverse'
}, lollipopColorVariablesLight['colors/backgrounds/inverse'], lollipopColorVariablesDark['colors/backgrounds/inverse'], pancakeColorVariablesLight['colors/backgrounds/inverse'], pancakeColorVariablesDark['colors/backgrounds/inverse']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/inverse' instead.
 */
export var __backgroundDefaultFloating = createVersionedColorDeprecated('__backgroundDefaultFloating', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/inverse'
}, lollipopColorVariablesLight['colors/backgrounds/inverse'].default_, lollipopColorVariablesDark['colors/backgrounds/inverse'].default_, pancakeColorVariablesLight['colors/backgrounds/inverse'].default_, pancakeColorVariablesDark['colors/backgrounds/inverse'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/inverse' instead.
 */
export var __backgroundDisabled = createVersionedColorDeprecated('__backgroundDisabled', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/inverse'
},
// workaround, because in lollipop disabled colors are part of the color variables
lollipopColorVariablesLight['colors/backgrounds/inverse'].disabled, lollipopColorVariablesDark['colors/backgrounds/inverse'].disabled, pancakeColorVariablesLight['colors/backgrounds/inverse'].disabled, pancakeColorVariablesDark['colors/backgrounds/inverse'].disabled);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/subtle-floating' instead.
 */
export var __backgroundDisabledWithBorder = createVersionedColorDeprecated('__backgroundDisabledWithBorder', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/subtle-floating'
},
// workaround, because in lollipop disabled colors are part of the color variables
lollipopColorVariablesLight['colors/backgrounds/subtle-floating'].disabled, lollipopColorVariablesDark['colors/backgrounds/subtle-floating'].disabled, pancakeColorVariablesLight['colors/backgrounds/subtle-floating'].disabled, pancakeColorVariablesDark['colors/backgrounds/subtle-floating'].disabled);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/error-inline' instead.
 */
export var [__backgroundErrorWithBorder, __backgroundErrorWithBorderHovered, __backgroundErrorWithBorderPressed] = colorVersionBuilderDeprecated(['__backgroundErrorWithBorder', '__backgroundErrorWithBorderHovered', '__backgroundErrorWithBorderPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/error-inline'
}, lollipopColorVariablesLight['colors/backgrounds/error-inline'], lollipopColorVariablesDark['colors/backgrounds/error-inline'], pancakeColorVariablesLight['colors/backgrounds/error-inline'], pancakeColorVariablesDark['colors/backgrounds/error-inline']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/error-inline' instead.
 */
export var [__backgroundErrorInline, __backgroundErrorInlineHovered, __backgroundErrorInlinePressed] = colorVersionBuilderDeprecated(['__backgroundErrorInline', '__backgroundErrorInlineHovered', '__backgroundErrorInlinePressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/error-inline'
}, lollipopColorVariablesLight['colors/backgrounds/error-inline'], lollipopColorVariablesDark['colors/backgrounds/error-inline'], pancakeColorVariablesLight['colors/backgrounds/error-inline'], pancakeColorVariablesDark['colors/backgrounds/error-inline']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/error-floating' instead.
 */
export var [__backgroundErrorFloating, __backgroundErrorFloatingHovered, __backgroundErrorFloatingPressed] = colorVersionBuilderDeprecated(['__backgroundErrorFloating', '__backgroundErrorFloatingHovered', '__backgroundErrorFloatingPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/error-floating'
}, lollipopColorVariablesLight['colors/backgrounds/error-floating'], lollipopColorVariablesDark['colors/backgrounds/error-floating'], pancakeColorVariablesLight['colors/backgrounds/error-floating'], pancakeColorVariablesDark['colors/backgrounds/error-floating']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/warning-inline' instead.
 */
export var [__backgroundWarningWithBorder, __backgroundWarningWithBorderHovered, __backgroundWarningWithBorderPressed] = colorVersionBuilderDeprecated(['__backgroundWarningWithBorder', '__backgroundWarningWithBorderHovered', '__backgroundWarningWithBorderPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/warning-inline'
}, lollipopColorVariablesLight['colors/backgrounds/warning-inline'], lollipopColorVariablesDark['colors/backgrounds/warning-inline'], pancakeColorVariablesLight['colors/backgrounds/warning-inline'], pancakeColorVariablesDark['colors/backgrounds/warning-inline']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/warning-inline' instead.
 */
export var [__backgroundWarningInline, __backgroundWarningInlineHovered, __backgroundWarningInlinePressed] = colorVersionBuilderDeprecated(['__backgroundWarningInline', '__backgroundWarningInlineHovered', '__backgroundWarningInlinePressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/warning-inline'
}, lollipopColorVariablesLight['colors/backgrounds/warning-inline'], lollipopColorVariablesDark['colors/backgrounds/warning-inline'], pancakeColorVariablesLight['colors/backgrounds/warning-inline'], pancakeColorVariablesDark['colors/backgrounds/warning-inline']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/warning-floating' instead.
 */
export var [__backgroundWarningFloating, __backgroundWarningFloatingHovered, __backgroundWarningFloatingPressed] = colorVersionBuilderDeprecated(['__backgroundWarningFloating', '__backgroundWarningFloatingHovered', '__backgroundWarningFloatingPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/warning-floating'
}, lollipopColorVariablesLight['colors/backgrounds/warning-floating'], lollipopColorVariablesDark['colors/backgrounds/warning-floating'], pancakeColorVariablesLight['colors/backgrounds/warning-floating'], pancakeColorVariablesDark['colors/backgrounds/warning-floating']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/success-inline' instead.
 */
export var [__backgroundSuccessWithBorder, __backgroundSuccessWithBorderHovered, __backgroundSuccessWithBorderPressed] = colorVersionBuilderDeprecated(['__backgroundSuccessWithBorder', '__backgroundSuccessWithBorderHovered', '__backgroundSuccessWithBorderPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/success-inline'
}, lollipopColorVariablesLight['colors/backgrounds/success-inline'], lollipopColorVariablesDark['colors/backgrounds/success-inline'], pancakeColorVariablesLight['colors/backgrounds/success-inline'], pancakeColorVariablesDark['colors/backgrounds/success-inline']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/success-inline' instead.
 */
export var [__backgroundSuccessInline, __backgroundSuccessInlineHovered, __backgroundSuccessInlinePressed] = colorVersionBuilderDeprecated(['__backgroundSuccessInline', '__backgroundSuccessInlineHovered', '__backgroundSuccessInlinePressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/success-inline'
}, lollipopColorVariablesLight['colors/backgrounds/success-inline'], lollipopColorVariablesDark['colors/backgrounds/success-inline'], pancakeColorVariablesLight['colors/backgrounds/success-inline'], pancakeColorVariablesDark['colors/backgrounds/success-inline']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/backgrounds/success-floating' instead.
 */
export var [__backgroundSuccessFloating, __backgroundSuccessFloatingHovered, __backgroundSuccessFloatingPressed] = colorVersionBuilderDeprecated(['__backgroundSuccessFloating', '__backgroundSuccessFloatingHovered', '__backgroundSuccessFloatingPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/backgrounds/success-floating'
}, lollipopColorVariablesLight['colors/backgrounds/success-floating'], lollipopColorVariablesDark['colors/backgrounds/success-floating'], pancakeColorVariablesLight['colors/backgrounds/success-floating'], pancakeColorVariablesDark['colors/backgrounds/success-floating']);

// Text

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/default' instead.
 */
export var [__textDefault, __textDefaultHovered, __textDefaultPressed] = colorVersionBuilderDeprecated(['__textDefault', '__textDefaultHovered', '__textDefaultPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/default'
}, lollipopColorVariablesLight['colors/text/default'], lollipopColorVariablesDark['colors/text/default'], pancakeColorVariablesLight['colors/text/default'], pancakeColorVariablesDark['colors/text/default']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/neutral' instead.
 */
export var [__textNeutral, __textNeutralHovered, __textNeutralPressed] = colorVersionBuilderDeprecated(['__textNeutral', '__textNeutralHovered', '__textNeutralPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/neutral'
}, lollipopColorVariablesLight['colors/text/neutral'], lollipopColorVariablesDark['colors/text/neutral'], pancakeColorVariablesLight['colors/text/neutral'], pancakeColorVariablesDark['colors/text/neutral']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/neutral-on-background' instead.
 */
export var [__textNeutralOnBackground, __textNeutralOnBackgroundHovered, __textNeutralOnBackgroundPressed] = colorVersionBuilderDeprecated(['__textNeutralOnBackground', '__textNeutralOnBackgroundHovered', '__textNeutralOnBackgroundPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/neutral-on-background'
}, lollipopColorVariablesLight['colors/text/neutral-on-background'], lollipopColorVariablesDark['colors/text/neutral-on-background'], pancakeColorVariablesLight['colors/text/neutral-on-background'], pancakeColorVariablesDark['colors/text/neutral-on-background']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/accent' instead.
 */
export var [__textAccent, __textAccentHovered, __textAccentPressed] = colorVersionBuilderDeprecated(['__textAccent', '__textAccentHovered', '__textAccentPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/accent'
}, lollipopColorVariablesLight['colors/text/accent'], lollipopColorVariablesDark['colors/text/accent'], pancakeColorVariablesLight['colors/text/accent'], pancakeColorVariablesDark['colors/text/accent']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/accent' instead.
 */
export var __textAccentDisabled = createVersionedColorDeprecated('__textAccentDisabled', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/accent'
},
// workaround, because in lollipop disabled colors are part of the color variables
lollipopColorVariablesLight['colors/text/accent'].disabled, lollipopColorVariablesDark['colors/text/accent'].disabled, pancakeColorVariablesLight['colors/text/accent'].disabled, pancakeColorVariablesDark['colors/text/accent'].disabled);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/accent-on-background' instead.
 */
export var [__textAccentOnBackground, __textAccentOnBackgroundHovered, __textAccentOnBackgroundPressed] = colorVersionBuilderDeprecated(['__textAccentOnBackground', '__textAccentOnBackgroundHovered', '__textAccentOnBackgroundPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/accent-on-background'
}, lollipopColorVariablesLight['colors/text/accent-on-background'], lollipopColorVariablesDark['colors/text/accent-on-background'], pancakeColorVariablesLight['colors/text/accent-on-background'], pancakeColorVariablesDark['colors/text/accent-on-background']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/inverse' instead.
 */
export var [__textInverse, __textInverseHovered, __textInversePressed] = colorVersionBuilderDeprecated(['__textInverse', '__textInverseHovered', '__textInversePressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/inverse'
}, lollipopColorVariablesLight['colors/text/inverse'], lollipopColorVariablesDark['colors/text/inverse'], pancakeColorVariablesLight['colors/text/inverse'], pancakeColorVariablesDark['colors/text/inverse']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/inverse' instead.
 */
export var __textInverseDisabled = createVersionedColorDeprecated('__textInverseDisabled', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/inverse'
},
// workaround, because in lollipop disabled colors are part of the color variables
lollipopColorVariablesLight['colors/text/inverse'].disabled, lollipopColorVariablesDark['colors/text/inverse'].disabled, pancakeColorVariablesLight['colors/text/inverse'].disabled, pancakeColorVariablesDark['colors/text/inverse'].disabled);

// Missing in Figma
/**
 * @deprecated this constant is outdated and will be removed with v6.0.0
 */
export var [__textInverseOnBackground, __textInverseOnBackgroundHovered, __textInverseOnBackgroundPressed] = colorVersionBuilderDeprecated(['__textInverseOnBackground', '__textInverseOnBackgroundHovered', '__textInverseOnBackgroundPressed'], {
  removalDate: 'v6.0.0'
}, lollipopColorVariablesLight['colors/text/inverse-on-background'], lollipopColorVariablesDark['colors/text/inverse-on-background'], pancakeColorVariablesLight['colors/text/inverse-on-background'], pancakeColorVariablesDark['colors/text/inverse-on-background']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/default' instead.
 */
export var __textDisabled = createVersionedColorDeprecated('__textDisabled', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/default'
},
// workaround, because in lollipop disabled colors are part of the color variables
lollipopColorVariablesLight['colors/text/default'].disabled, lollipopColorVariablesDark['colors/text/default'].disabled, pancakeColorVariablesLight['colors/text/default'].disabled, pancakeColorVariablesDark['colors/text/default'].disabled);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0
 */
export var __textDisabledOnBackground = createVersionedColorDeprecated('__textDisabledOnBackground', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system'
},
// Workaround: not defined by design
new Color('#F0F1F1'), new Color('#252728'), new Color('#F0F1F1'), new Color('#252728'));

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/error' instead.
 */
export var [__textError, __textErrorHovered, __textErrorPressed] = colorVersionBuilderDeprecated(['__textError', '__textErrorHovered', '__textErrorPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/error'
}, lollipopColorVariablesLight['colors/text/error'], lollipopColorVariablesDark['colors/text/error'], pancakeColorVariablesLight['colors/text/error'], pancakeColorVariablesDark['colors/text/error']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/warning' instead.
 */
export var __textWarning = createVersionedColorDeprecated('__textWarning', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/warning'
}, lollipopColorVariablesLight['colors/text/warning'].default_, lollipopColorVariablesDark['colors/text/warning'].default_, pancakeColorVariablesLight['colors/text/warning'].default_, pancakeColorVariablesDark['colors/text/warning'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/success' instead.
 */
export var __textSuccess = createVersionedColorDeprecated('__textSuccess', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/success'
}, lollipopColorVariablesLight['colors/text/success'].default_, lollipopColorVariablesDark['colors/text/success'].default_, pancakeColorVariablesLight['colors/text/success'].default_, pancakeColorVariablesDark['colors/text/success'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/default' instead.
 */
export var [__iconDefault, __iconDefaultHovered, __iconDefaultPressed] = colorVersionBuilderDeprecated(['__iconDefault', '__iconDefaultHovered', '__iconDefaultPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/default'
}, lollipopColorVariablesLight['colors/text/default'], lollipopColorVariablesDark['colors/text/default'], pancakeColorVariablesLight['colors/text/default'], pancakeColorVariablesDark['colors/text/default']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/neutral' instead.
 */
export var [__iconNeutral, __iconNeutralHovered, __iconNeutralPressed] = colorVersionBuilderDeprecated(['__iconNeutral', '__iconNeutralHovered', '__iconNeutralPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/neutral'
}, lollipopColorVariablesLight['colors/text/neutral'], lollipopColorVariablesDark['colors/text/neutral'], pancakeColorVariablesLight['colors/text/neutral'], pancakeColorVariablesDark['colors/text/neutral']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/neutral-on-background' instead.
 */
export var [__iconNeutralOnBackground, __iconNeutralOnBackgroundHovered, __iconNeutralOnBackgroundPressed] = colorVersionBuilderDeprecated(['__iconNeutralOnBackground', '__iconNeutralOnBackgroundHovered', '__iconNeutralOnBackgroundPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/neutral-on-background'
}, lollipopColorVariablesLight['colors/text/neutral-on-background'], lollipopColorVariablesDark['colors/text/neutral-on-background'], pancakeColorVariablesLight['colors/text/neutral-on-background'], pancakeColorVariablesDark['colors/text/neutral-on-background']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/neutral' instead.
 */
export var [__iconNeutralThickFont, __iconNeutralThickFontHovered, __iconNeutralThickFontPressed] = colorVersionBuilderDeprecated(['__iconNeutralThickFont', '__iconNeutralThickFontHovered', '__iconNeutralThickFontPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/neutral'
}, lollipopColorVariablesLight['colors/text/neutral'], lollipopColorVariablesDark['colors/text/neutral'], pancakeColorVariablesLight['colors/text/neutral'], pancakeColorVariablesDark['colors/text/neutral']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/inverse' instead.
 */
export var __iconInverseDisabled = createVersionedColorDeprecated('__iconInverseDisabled', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/inverse'
}, lollipopColorVariablesLight['colors/text/inverse'].disabled, lollipopColorVariablesDark['colors/text/inverse'].disabled, pancakeColorVariablesLight['colors/text/inverse'].disabled, pancakeColorVariablesDark['colors/text/inverse'].disabled);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/inverse' instead.
 */
export var [__iconInverse, __iconInverseHovered, __iconInversePressed] = colorVersionBuilderDeprecated(['__iconInverse', '__iconInverseHovered', '__iconInversePressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/inverse'
}, lollipopColorVariablesLight['colors/text/inverse'], lollipopColorVariablesDark['colors/text/inverse'], pancakeColorVariablesLight['colors/text/inverse'], pancakeColorVariablesDark['colors/text/inverse']);

// Missing in Figma
/**
 * @deprecated this constant is outdated and will be removed with v6.0.0
 */
export var [__iconInverseOnBackground, __iconInverseOnBackgroundHovered, __iconInverseOnBackgroundPressed] = colorVersionBuilderDeprecated(['__iconInverseOnBackground', '__iconInverseOnBackgroundHovered', '__iconInverseOnBackgroundPressed'], {
  removalDate: 'v6.0.0'
}, lollipopColorVariablesLight['colors/text/inverse-on-background'], lollipopColorVariablesDark['colors/text/inverse-on-background'], pancakeColorVariablesLight['colors/text/inverse-on-background'], pancakeColorVariablesDark['colors/text/inverse-on-background']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/accent' instead.
 */
export var __iconAccentDisabled = createVersionedColorDeprecated('__iconAccentDisabled', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/accent'
},
// workaround, because in lollipop disabled colors are part of the color variables
lollipopColorVariablesLight['colors/text/accent'].disabled, lollipopColorVariablesDark['colors/text/accent'].disabled, pancakeColorVariablesLight['colors/text/accent'].disabled, pancakeColorVariablesDark['colors/text/accent'].disabled);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/accent' instead.
 */
export var [__iconAccent, __iconAccentHovered, __iconAccentPressed] = colorVersionBuilderDeprecated(['__iconAccent', '__iconAccentHovered', '__iconAccentPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/accent'
}, lollipopColorVariablesLight['colors/text/accent'], lollipopColorVariablesDark['colors/text/accent'], pancakeColorVariablesLight['colors/text/accent'], pancakeColorVariablesDark['colors/text/accent']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/accent-on-background' instead.
 */
export var [__iconAccentOnBackground, __iconAccentOnBackgroundHovered, __iconAccentOnBackgroundPressed] = colorVersionBuilderDeprecated(['__iconAccentOnBackground', '__iconAccentOnBackgroundHovered', '__iconAccentOnBackgroundPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/accent-on-background'
}, lollipopColorVariablesLight['colors/text/accent-on-background'], lollipopColorVariablesDark['colors/text/accent-on-background'], pancakeColorVariablesLight['colors/text/accent-on-background'], pancakeColorVariablesDark['colors/text/accent-on-background']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/default' instead.
 */
export var __iconDisabled = createVersionedColorDeprecated('__iconDisabled', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/default'
},
// workaround, because in lollipop disabled colors are part of the color variables
lollipopColorVariablesLight['colors/text/default'].disabled, lollipopColorVariablesDark['colors/text/default'].disabled, pancakeColorVariablesLight['colors/text/default'].disabled, pancakeColorVariablesDark['colors/text/default'].disabled);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0
 */
export var __iconDisabledOnBackground = createVersionedColorDeprecated('__iconDisabledOnBackground', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system'
},
// Workaround: not defined by design
new Color('#F0F1F1'), new Color('#252728'), new Color('#F0F1F1'), new Color('#252728'));

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/error' instead.
 */
export var [__iconError, __iconErrorHovered, __iconErrorPressed] = colorVersionBuilderDeprecated(['__iconError', '__iconErrorHovered', '__iconErrorPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/error'
}, lollipopColorVariablesLight['colors/text/error'], lollipopColorVariablesDark['colors/text/error'], pancakeColorVariablesLight['colors/text/error'], pancakeColorVariablesDark['colors/text/error']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/error' instead.
 */
export var [__iconErrorThickFont, __iconErrorThickFontHovered, __iconErrorThickFontPressed] = colorVersionBuilderDeprecated(['__iconErrorThickFont', '__iconErrorThickFontHovered', '__iconErrorThickFontPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/error'
}, lollipopColorVariablesLight['colors/text/error'], lollipopColorVariablesDark['colors/text/error'], pancakeColorVariablesLight['colors/text/error'], pancakeColorVariablesDark['colors/text/error']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/warning' instead.
 */
export var [__iconWarning, __iconWarningHovered, __iconWarningPressed] = colorVersionBuilderDeprecated(['__iconWarning', '__iconWarningHovered', '__iconWarningPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/warning'
}, lollipopColorVariablesLight['colors/text/warning'], lollipopColorVariablesDark['colors/text/warning'], pancakeColorVariablesLight['colors/text/warning'], pancakeColorVariablesDark['colors/text/warning']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/warning' instead.
 */
export var [__iconWarningThickFont, __iconWarningThickFontHovered, __iconWarningThickFontPressed] = colorVersionBuilderDeprecated(['__iconWarningThickFont', '__iconWarningThickFontHovered', '__iconWarningThickFontPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/warning'
}, lollipopColorVariablesLight['colors/text/warning'], lollipopColorVariablesDark['colors/text/warning'], pancakeColorVariablesLight['colors/text/warning'], pancakeColorVariablesDark['colors/text/warning']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/success' instead.
 */
export var [__iconSuccess, __iconSuccessHovered, __iconSuccessPressed] = colorVersionBuilderDeprecated(['__iconSuccess', '__iconSuccessHovered', '__iconSuccessPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/success'
}, lollipopColorVariablesLight['colors/text/success'], lollipopColorVariablesDark['colors/text/success'], pancakeColorVariablesLight['colors/text/success'], pancakeColorVariablesDark['colors/text/success']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/text/success' instead.
 */
export var [__iconSuccessThickFont, __iconSuccessThickFontHovered, __iconSuccessThickFontPressed] = colorVersionBuilderDeprecated(['__iconSuccessThickFont', '__iconSuccessThickFontHovered', '__iconSuccessThickFontPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/text/success'
}, lollipopColorVariablesLight['colors/text/success'], lollipopColorVariablesDark['colors/text/success'], pancakeColorVariablesLight['colors/text/success'], pancakeColorVariablesDark['colors/text/success']);

// Borders

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/borders/accent' instead.
 */
export var [__borderAccent, __borderAccentHovered, __borderAccentPressed] = colorVersionBuilderDeprecated(['__borderAccent', '__borderAccentHovered', '__borderAccentPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/borders/accent'
}, lollipopColorVariablesLight['colors/borders/accent'], lollipopColorVariablesDark['colors/borders/accent'], pancakeColorVariablesLight['colors/borders/accent'], pancakeColorVariablesDark['colors/borders/accent']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/borders/subtle-inline' instead.
 */
export var [__borderSubtleInline, __borderSubtleInlineHovered, __borderSubtleInlinePressed] = colorVersionBuilderDeprecated(['__borderSubtleInline', '__borderSubtleInlineHovered', '__borderSubtleInlinePressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/borders/subtle-inline'
}, lollipopColorVariablesLight['colors/borders/subtle-inline'], lollipopColorVariablesDark['colors/borders/subtle-inline'], pancakeColorVariablesLight['colors/borders/subtle-inline'], pancakeColorVariablesDark['colors/borders/subtle-inline']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/borders/subtle-floating' instead.
 */
export var __borderSubtleFloating = createVersionedColorDeprecated('__borderSubtleFloating', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/borders/subtle-floating'
}, lollipopColorVariablesLight['colors/borders/subtle-floating'].default_, lollipopColorVariablesDark['colors/borders/subtle-floating'].default_, pancakeColorVariablesLight['colors/borders/subtle-floating'].default_, pancakeColorVariablesDark['colors/borders/subtle-floating'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. use color token 'colors/borders/neutral' instead.
 */
export var [__borderNeutral, __borderNeutralHovered, __borderNeutralPressed] = colorVersionBuilderDeprecated(['__borderNeutral', '__borderNeutralHovered', '__borderNeutralPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/borders/neutral'
}, lollipopColorVariablesLight['colors/borders/neutral'], lollipopColorVariablesDark['colors/borders/neutral'], pancakeColorVariablesLight['colors/borders/neutral'], pancakeColorVariablesDark['colors/borders/neutral']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/borders/default' instead.
 */
export var [__borderDefault, __borderDefaultHovered, __borderDefaultPressed] = colorVersionBuilderDeprecated(['__borderDefault', '__borderDefaultHovered', '__borderDefaultPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/borders/default'
}, lollipopColorVariablesLight['colors/borders/default'], lollipopColorVariablesDark['colors/borders/default'], pancakeColorVariablesLight['colors/borders/default'], pancakeColorVariablesDark['colors/borders/default']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/borders/default' instead.
 */
export var __borderDisabled = createVersionedColorDeprecated('__borderDisabled', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/borders/default'
},
// workaround, because in lollipop disabled colors are part of the color variables
lollipopColorVariablesLight['colors/borders/default'].disabled, lollipopColorVariablesDark['colors/borders/default'].disabled, pancakeColorVariablesLight['colors/borders/default'].disabled, pancakeColorVariablesDark['colors/borders/default'].disabled);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/borders/error' instead.
 */
export var [__borderError, __borderErrorHovered, __borderErrorPressed] = colorVersionBuilderDeprecated(['__borderError', '__borderErrorHovered', '__borderErrorPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/borders/error'
}, lollipopColorVariablesLight['colors/borders/error'], lollipopColorVariablesDark['colors/borders/error'], pancakeColorVariablesLight['colors/borders/error'], pancakeColorVariablesDark['colors/borders/error']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/borders/warning' instead.
 */
export var [__borderWarning, __borderWarningHovered, __borderWarningPressed] = colorVersionBuilderDeprecated(['__borderWarning', '__borderWarningHovered', '__borderWarningPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/borders/warning'
}, lollipopColorVariablesLight['colors/borders/warning'], lollipopColorVariablesDark['colors/borders/warning'], pancakeColorVariablesLight['colors/borders/warning'], pancakeColorVariablesDark['colors/borders/warning']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/borders/success' instead.
 */
export var [__borderSuccess, __borderSuccessHovered, __borderSuccessPressed] = colorVersionBuilderDeprecated(['__borderSuccess', '__borderSuccessHovered', '__borderSuccessPressed'], {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/borders/success'
}, lollipopColorVariablesLight['colors/borders/success'], lollipopColorVariablesDark['colors/borders/success'], pancakeColorVariablesLight['colors/borders/success'], pancakeColorVariablesDark['colors/borders/success']);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0
 */
export var __shadowSmall = createVersionedColorDeprecated('__shadowSmall', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system'
}, Black15, Black80, Black15, Black80);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0
 */
export var __shadowMedium = createVersionedColorDeprecated('__shadowMedium', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system'
}, Black15, Black80, Black15, Black80);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0
 */
export var __shadowLarge = createVersionedColorDeprecated('__shadowLarge', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system'
}, Black15, Black80, Black15, Black80);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/data/mono/front-value' instead.
 */
export var __dataHighlight = createVersionedColorDeprecated('__dataHighlight', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/data/mono/front-value'
}, lollipopColorVariablesLight['colors/data/mono/front-value'].default_, lollipopColorVariablesDark['colors/data/mono/front-value'].default_, pancakeColorVariablesLight['colors/data/mono/front-value'].default_, pancakeColorVariablesDark['colors/data/mono/front-value'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/data/colored/value-01' instead.
 */
export var __dataColoredOne = createVersionedColorDeprecated('__dataColoredOne', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/data/colored/value-01'
}, lollipopColorVariablesLight['colors/data/colored/value-01'].default_, lollipopColorVariablesDark['colors/data/colored/value-01'].default_, pancakeColorVariablesLight['colors/data/colored/value-01'].default_, pancakeColorVariablesDark['colors/data/colored/value-01'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/data/colored/value-02' instead.
 */
export var __dataColoredTwo = createVersionedColorDeprecated('__dataColoredTwo', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/data/colored/value-02'
}, lollipopColorVariablesLight['colors/data/colored/value-02'].default_, lollipopColorVariablesDark['colors/data/colored/value-02'].default_, pancakeColorVariablesLight['colors/data/colored/value-02'].default_, pancakeColorVariablesDark['colors/data/colored/value-02'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/data/colored/value-03' instead.
 */
export var __dataColoredThree = createVersionedColorDeprecated('__dataColoredThree', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/data/colored/value-03'
}, lollipopColorVariablesLight['colors/data/colored/value-03'].default_, lollipopColorVariablesDark['colors/data/colored/value-03'].default_, pancakeColorVariablesLight['colors/data/colored/value-03'].default_, pancakeColorVariablesDark['colors/data/colored/value-03'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/data/colored/value-04' instead.
 */
export var __dataColoredFour = createVersionedColorDeprecated('__dataColoredFour', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/data/colored/value-04'
}, lollipopColorVariablesLight['colors/data/colored/value-04'].default_, lollipopColorVariablesDark['colors/data/colored/value-04'].default_, pancakeColorVariablesLight['colors/data/colored/value-04'].default_, pancakeColorVariablesDark['colors/data/colored/value-04'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/data/colored/value-05' instead.
 */
export var __dataColoredFive = createVersionedColorDeprecated('__dataColoredFive', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/data/colored/value-05'
}, lollipopColorVariablesLight['colors/data/colored/value-05'].default_, lollipopColorVariablesDark['colors/data/colored/value-05'].default_, pancakeColorVariablesLight['colors/data/colored/value-05'].default_, pancakeColorVariablesDark['colors/data/colored/value-05'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/data/colored/value-06' instead.
 */
export var __dataColoredSix = createVersionedColorDeprecated('__dataColoredSix', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/data/colored/value-06'
}, lollipopColorVariablesLight['colors/data/colored/value-06'].default_, lollipopColorVariablesDark['colors/data/colored/value-06'].default_, pancakeColorVariablesLight['colors/data/colored/value-06'].default_, pancakeColorVariablesDark['colors/data/colored/value-06'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/data/colored/value-07' instead.
 */
export var __dataColoredSeven = createVersionedColorDeprecated('__dataColoredSeven', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/data/colored/value-07'
}, lollipopColorVariablesLight['colors/data/colored/value-07'].default_, lollipopColorVariablesDark['colors/data/colored/value-07'].default_, pancakeColorVariablesLight['colors/data/colored/value-07'].default_, pancakeColorVariablesDark['colors/data/colored/value-07'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/data/colored/value-08' instead.
 */
export var __dataColoredEight = createVersionedColorDeprecated('__dataColoredEight', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/data/colored/value-08'
}, lollipopColorVariablesLight['colors/data/colored/value-08'].default_, lollipopColorVariablesDark['colors/data/colored/value-08'].default_, pancakeColorVariablesLight['colors/data/colored/value-08'].default_, pancakeColorVariablesDark['colors/data/colored/value-08'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/data/mono/front-value' instead.
 */
export var __dataMonochromeOne = createVersionedColorDeprecated('__dataMonochromeOne', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/data/mono/front-value'
}, lollipopColorVariablesLight['colors/data/mono/front-value'].default_, lollipopColorVariablesDark['colors/data/mono/front-value'].default_, pancakeColorVariablesLight['colors/data/mono/front-value'].default_, pancakeColorVariablesDark['colors/data/mono/front-value'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/data/mono/average-value' instead.
 */
export var __dataMonochromeTwo = createVersionedColorDeprecated('__dataMonochromeTwo', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/data/mono/average-value'
}, lollipopColorVariablesLight['colors/data/mono/average-value'].default_, lollipopColorVariablesDark['colors/data/mono/average-value'].default_, pancakeColorVariablesLight['colors/data/mono/average-value'].default_, pancakeColorVariablesDark['colors/data/mono/average-value'].default_);

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0. Use color token 'colors/data/mono/rear-value' instead.
 */
export var __dataMonochromeThree = createVersionedColorDeprecated('__dataMonochromeThree', {
  removalDate: 'v6.0.0',
  readMore: 'https://bubble-ui.klarna.net/#design-tokens/color-system',
  useInstead: 'colors/data/mono/rear-value'
}, lollipopColorVariablesLight['colors/data/mono/rear-value'].default_, lollipopColorVariablesDark['colors/data/mono/rear-value'].default_, pancakeColorVariablesLight['colors/data/mono/rear-value'].default_, pancakeColorVariablesDark['colors/data/mono/rear-value'].default_);
//# sourceMappingURL=colorVariables.js.map